import React, {useEffect, useState} from "react";
import {useIsMobile, useLanguage} from "../../configuration/configuration";
import {TooltipButton, TooltipLink} from "../../navigation/buttons/nav-buttons";
import {useDispatch} from "react-redux";
import {asyncAddFriend, chatEventHandler, EVENT_CHAT_PENDING} from "../../../actions";
import {useAuthorization, useFriendData, useHomeData} from "../../../selectors";
import {notify, notifyWarning} from "../../notifications/notify";
import {
    ChatIcon,
    PersonAddIcon,
    ScheduleIcon,
    fs_bigger,
    GroupIcon,
    fs_regular
} from "../../navigation/icons/nav-icons";

const HomeUserNavigation = ({username}) => {
    const {isAuthorized, principalUsername} = useAuthorization();
    const [identity, setIdentity] = useState({isGeneric: false, isSelf: false, isOther: false,});
    const {homedata, isFriend, calendarVisibility, friendsVisibility} = useHomeData();
    const {incomingChat} = useFriendData();
    const isMobile = useIsMobile();

    const Lang = useLanguage();
    const dispatch = useDispatch();

    const handleAddFriend = (event) => {
        dispatch(asyncAddFriend(principalUsername, username, friend => {
                notifyWarning(Lang.user.nav.friendshipRequested(friend.friend.firstname));
            })
        );
    }

    useEffect(() => {
        setIdentity({
            isGeneric: !isAuthorized || (username !== principalUsername),
            isSelf: isAuthorized && username === principalUsername,
            isOther: isAuthorized && username !== principalUsername,
        })
    }, [username]);

    useEffect(() => {
        if (incomingChat) {
            const isSelf = username === principalUsername;
            const isConsumed = incomingChat.state === 'CONSUMED' || incomingChat.state === 'PENDING';
            if (isSelf && !isConsumed) {
                dispatch(chatEventHandler(EVENT_CHAT_PENDING, null));
                notify(Lang.chat.info.newArrived(incomingChat.from));
            }
        }
    }, [incomingChat])

    const resolveFriendsHome = () => {
        if(!identity.isSelf) {
            if(friendsVisibility.isNone) {
                return `/${username}/restricted?page=FRIENDS&visibility=NONE`;

            } else if (friendsVisibility.isFriends && !isFriend) {
                return `/${username}/restricted?page=FRIENDS&visibility=FRIENDS`;
            }
        }
        if(isMobile) {
            return `/${username}/friends/mobile`;
        }
        return `/${username}/friends`
    }

    const renderFriendButtons = () => {
        const {space, isFriend, chatCount} = homedata;
        const firstname = space.user.firstname;

        return <>
            {identity.isSelf && <div className="d-flex align-items-center">
                {chatCount > 0 && <span className="badge rounded-pill bg-danger mr-1">{chatCount}</span>}
                <TooltipLink className='role-simple-btn mr-3'
                             title={Lang.generic.nav.friends.chat}
                             to={resolveFriendsHome()}>
                    <div className="d-flex align-items-center clr-white">
                            <ChatIcon size={fs_bigger} className="mr-1"/>
                        <span className='generic-navigation-text'>{Lang.generic.nav.friends.chat}</span>
                    </div>
                </TooltipLink></div>}

            {!identity.isSelf && <TooltipLink className='role-simple-btn mr-3'
                                             title={Lang.generic.nav.friends.generic}
                                             to={resolveFriendsHome()}>
                <div className="d-flex align-items-center clr-white">
                    <GroupIcon size={fs_regular} className="mr-1"/>
                    <span className='generic-navigation-text'>{Lang.generic.nav.friends.generic}</span>
                </div>
            </TooltipLink>}

            {!isMobile && identity.isSelf && homedata.pending > 0 &&
            <TooltipLink className='role-simple-btn mr-3'
                              title={Lang.user.nav.pendingTooltip(firstname)}
                              // to={`/${username}/pending`}>
                         to={resolveFriendsHome()}>
                <div className="d-flex align-items-center clr-white">
                    <ScheduleIcon size={fs_bigger}/>
                    <span className='generic-navigation-text'>{homedata.pending} {Lang.user.nav.pending}</span>
                </div>
            </TooltipLink>}

            {!identity.isSelf && !isFriend &&
            <TooltipButton className='role-simple-btn clr-white mr-3'
                                title={Lang.user.nav.addFriendTooltip(firstname)}
                                onClick={handleAddFriend}>
                <PersonAddIcon size={fs_bigger} className="mr-1"/>
                <span className='generic-navigation-text'>{Lang.user.nav.addFriend}</span>
            </TooltipButton>}
        </>
    };

    return <div className='generic-navigation-buttons'>
        {isAuthorized &&
        renderFriendButtons()}
    </div>
};

export default HomeUserNavigation;